import { Dialog } from "primereact/dialog";
import React from "react";

export default function MarkedGenerated({ isPreview, setIsPreview, onSubmit }) {
  const [voucherNumber, setVoucherNumber] = React.useState("");

  return (
    <Dialog
      header="Mark Generated Invoice"
      visible={isPreview}
      onHide={() => {
        setVoucherNumber("");
        if (!isPreview) return;
        setIsPreview(false);
      }}
      style={{ height: "250px !important" }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          width: "100%",
          padding: "0 10px",
        }}
      >
        <div className="">
          <label>
            Voucher Number<span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Voucher Number"
            value={voucherNumber}
            onChange={(event) => setVoucherNumber(event.target.value)}
          />
        </div>

        <div className="" style={{ textAlign: "right" }}>
          <button
            onClick={() => {
              setVoucherNumber("");
              if (!isPreview) return;
              setIsPreview(false);
            }}
            className="btn btn-success ml-1"
          >
            Close
          </button>
          <button
            onClick={() => {
              onSubmit(voucherNumber);
              setIsPreview(false);
            }}
            className="btn btn-success ml-1 deliver-css"
          >
            Submit
          </button>
        </div>
      </div>
    </Dialog>
  );
}
